import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import DetailBarang from "../views/Barang/DetailBarang";
import Daftar from "../views/Daftar.vue";
import OTP from "../views/OTP.vue";
import FormByNumber from "../views/FormByNumber.vue";
import Login from "../views/Login.vue";
import Cart from "../views/Cart.vue";
import Shipment from "../views/Shipment.vue";
import Account from "../views/User/Account.vue";
import Produk from "../views/Produk.vue";
import Terms from "../views/Terms.vue";
import Privacy from "../views/Privacy.vue";
import Wishlist from "../views/User/Wishlist.vue";
import ComingSoon from "../components/ComingSoon.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/daftar",
    name: "Daftar",
    component: Daftar,
  },
  {
    path: "/daftar/bynumber/:hp",
    name: "OTP",
    component: OTP,
  },
  {
    path: "/daftar/bynumber/:hp/success",
    name: "FormByNumber",
    component: FormByNumber,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  // VIEW ACCOUNT----------------------------------------
  {
    path: "/account/:id",
    name: "Account",
    component: Account,
  },
  {
    path: "/wishlist",
    name: "Wishlist",
    component: Wishlist,
  },
  // VIEW BARANG-----------------------------------------
  {
    path: "/detail/:id",
    name: "DetailBarang",
    component: DetailBarang,
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
  },
  {
    path: "/cart/shipment",
    name: "Shipment",
    component: Shipment,
  },
  {
    path: "/product",
    name: "Produk",
    component: Produk,
  },
  // VIEW MAINTENANCE-------------------------------------
  {
    path: "/coming",
    name: "ComingSoon",
    component: ComingSoon,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
];

const router = new VueRouter({
  routes,
  // mode: "history",
});

export default router;
